import { IApplicationState } from '../../types/redux';
import { TDeviceType } from '@cian/ui-kit';
import { EPageType } from '../../types/page';

export function selectPageType(state: IApplicationState): EPageType | undefined {
  return state.page?.type;
}

export const selectDeviceType = (state: IApplicationState): TDeviceType => state.page.deviceType;
